/**
 * Подсказки для страницы «Скорость сайта»: на какой вопрос отвечает вкладка,
 * как её читать и что делать. Страницу открывают менеджер и тестировщики,
 * а не разработчики, поэтому без терминов там, где можно без них.
 */

export const TAB_GUIDE = {
    overview: {
        question: 'Всё ли в порядке с сайтом прямо сейчас?',
        read: [
            'Начинайте с фразы-вердикта вверху: она обобщает всё остальное.',
            'Четыре плитки — главные показатели. Цветная полоска под цифрой — сколько посетителей попало в зелёную, жёлтую и красную зону.',
            'Стрелка с процентом появляется, только если изменение к прошлому периоду заметное, а не шум.',
            'Блок «Что происходит» — готовые выводы, самые массовые проблемы сверху. У каждой есть «Что сделать».',
        ],
        worry: 'Вердикт «Плохо», красные плитки или выводы с пометкой «Срочно».',
        action: 'Перешлите разработчикам вывод целиком — в нём уже есть причина и цифры.',
    },
    pages: {
        question: 'Где сайт тормозит сильнее всего?',
        read: [
            'Каждая строка — тип страницы: все турниры считаются как одна строка «Турнир».',
            'Нажмите на заголовок столбца, чтобы отсортировать. Начните с «Просмотров»: медленная страница, которую мало кто открывает, менее важна.',
            'Под временем — изменение к прошлому периоду той же длины, если оно заметное.',
        ],
        worry: 'Популярная страница с оценкой «Плохо» или с красным процентом роста.',
        action: 'Назовите разработчикам страницу и показатель, который покраснел.',
    },
    audience: {
        question: 'Кому из посетителей хуже всего?',
        read: [
            'Сравнивайте строки внутри одного блока: телефоны с компьютерами, Telegram с обычным браузером.',
            'Строка с малой долей просмотров может быть случайной — смотрите на неё, только если просмотров заметно много.',
        ],
        worry: 'Большая группа (например, телефоны) с оценкой хуже, чем у остальных.',
        action: 'При проверке релиза воспроизводите на этой группе: тот же тип устройства, браузер, сеть.',
    },
    releases: {
        question: 'Не стал ли сайт медленнее после выкладки?',
        read: [
            'Сверху — самый свежий релиз. Каждый сравнивается с предыдущим, на котором хватило замеров.',
            '«Мало данных» — релиз вышел недавно или его мало открывали; подождите сутки.',
            'Справа — страницы, где изменение после релиза сильнее всего.',
        ],
        worry: 'Вердикт «Медленнее» у свежего релиза.',
        action: 'Сообщите разработчикам номер релиза и страницы из правого столбца.',
    },
    actions: {
        question: 'Теряем ли мы регистрации и заявки из-за скорости?',
        read: [
            'Конверсия — сколько действий приходится на один просмотр.',
            'Сравните «При быстрой загрузке» и «При медленной»: если при быстрой делают чаще, скорость влияет на результат.',
            '«Упущено» — сколько действий добавилось бы, если бы медленные просмотры вели себя как быстрые. Это оценка, а не точный счёт.',
        ],
        worry: 'Большая разница и заметное «Упущено» у важного действия.',
        action: 'Аргумент для приоритета задач на скорость: цифру «Упущено» можно нести в планирование.',
    },
    product: {
        question: 'Как быстро начинают работать кнопки и переходы?',
        read: [
            'Это замеры самого BIGPLAY, а не стандарт Google: когда страница ожила, сколько длится переход внутри сайта, когда кнопка «Участвовать» стала нажиматься.',
            '«Быстро у N%» — доля посетителей, которым не пришлось ждать.',
        ],
        worry: 'Кнопка «Участвовать» или «Страница ожила» с оценкой «Плохо».',
        action: 'Проверьте на телефоне: нажатие сразу после открытия страницы может не срабатывать.',
    },
    api: {
        question: 'Какие запросы к бэкенду медленные или ломаются?',
        read: [
            'Время — сколько посетитель ждал ответа, вместе с сетью. Поэтому по странам оно разное.',
            '«Ошибки» — ответ с кодом ошибки. «Без статуса» — ответа не было вообще: оборвалась сеть или старый браузер.',
        ],
        worry: 'Ошибки больше 5% (подсвечены красным) или частый запрос с ответом дольше секунды.',
        action: 'Передайте бэкенд-разработчикам адрес запроса и цифры из строки.',
    },
    scripts: {
        question: 'Какой код подвешивает браузер?',
        read: [
            'Пока браузер выполняет скрипт, страница не реагирует на нажатия.',
            '«Блокирует поток» — сколько миллисекунд в среднем на один просмотр занимает этот источник. Сверху — самые тяжёлые.',
            '«Свой код сайта» — это наш фронтенд; остальное — внешние сервисы: аналитика, виджеты, видео.',
        ],
        worry: 'Внешний сервис, который блокирует поток дольше, чем свой код.',
        action: 'Повод обсудить, нужен ли этот сервис на всех страницах.',
    },
    health: {
        question: 'У кого сайт падает или не открывается?',
        read: [
            '«С ошибками» — у скольких просмотров была хотя бы одна ошибка в браузере. Не каждая ошибка видна человеку.',
            '«Не загрузился код» — обычно сразу после деплоя у тех, кто держал вкладку открытой.',
            '«Сайт не запустился» — самое тяжёлое: человек так и не увидел работающую страницу.',
        ],
        worry: 'Рост «Сайт не запустился» или скачок ошибок у свежего релиза в таблице по релизам.',
        action: 'Сравните с релизом выше в таблице и сообщите разработчикам номер релиза.',
    },
}

export const GLOSSARY = [
    {
        term: 'У 75% посетителей',
        text: 'Три из четырёх посетителей дождались быстрее этой цифры, четвёртый — дольше. Так считает Google: среднее прячет тех, кому было плохо.',
    },
    {
        term: 'Зелёная, жёлтая, красная зона',
        text: 'Хорошо, терпимо и плохо по нормам Google. Цветная полоска показывает, сколько посетителей попало в каждую зону.',
    },
    {term: 'Загрузка (LCP)', text: 'Когда на экране появилось главное: картинка, заголовок, список турниров.'},
    {term: 'Отклик (INP)', text: 'Сколько ждать, пока страница отреагирует на нажатие.'},
    {term: 'Стабильность (CLS)', text: 'Насколько прыгает вёрстка, пока страница грузится. Чем меньше число, тем лучше; это не время.'},
    {term: 'Ответ сервера (TTFB)', text: 'Когда от сервера пришёл первый кусок страницы. Если тут плохо — тормозит не браузер, а сервер или сеть.'},
    {term: 'Отказ', text: 'Человек открыл страницу и ушёл, ничего на ней не сделав.'},
    {term: 'Релиз', text: 'Версия сайта после очередной выкладки. Позволяет увидеть, что изменилось именно из-за неё.'},
    {term: 'Заметное изменение', text: 'Сдвиг больше обычного шума и на достаточном числе замеров. Мелкие колебания стрелкой не показываются.'},
    {term: 'Мало данных', text: 'Замеров слишком мало, чтобы делать выводы. Возьмите период подлиннее или подождите.'},
]
